import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {RouterModule} from '@angular/router';
import {AuthLayoutComponent} from './auth-layout.component';

import {LottieComponent, provideLottieOptions} from 'ngx-lottie';
import {ToastContainerDirective, ToastrModule} from 'ngx-toastr';

export function playerFactory() {
  return import('lottie-web/build/player/lottie_svg');
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ToastrModule,
    LottieComponent,
    ToastContainerDirective,
    NgOptimizedImage,
    AuthLayoutComponent,
  ],
  providers: [provideLottieOptions({player: playerFactory})],
})
export class AuthLayoutModule {}
